module.exports = __webpack_public_path__ + "img/title01.e3e36140.png";